import { _apiV2_get } from "@/app/api2"
import { AllFiltersResponse, Filter, FiltersQueryParams } from "@/app/types"

export async function getAllFilters(): Promise<AllFiltersResponse> {
  return _apiV2_get("/meta/filters", {
    key: "defaultFilters",
  })
}

export async function setFilters(
  filters: FiltersQueryParams
): Promise<Filter.Type> {
  const stringifiedFilters: Record<string, string> = {
    mf: filters.mf.toString(),
    etf: filters.etf.toString(),
    active: filters.active.toString(),
    index: filters.index.toString(),
    fof: filters.fof.toString(),
    not_fof: filters.not_fof.toString(),
  }

  return _apiV2_get("/meta/filters", {
    key: "setFilters",
    queryParam: stringifiedFilters,
  })
}
